/**
 * Frontegg feature keys, one per row of the package matrix; plans grant them and a
 * section whose feature is missing is frosted. Strings must match the Frontegg setup.
 */
export const FROST_FEATURES = {
  portfolio: 'portfolio',
  entities: 'entity-management',
  finance: 'finance',
  dealsTab: 'company-deals-base',
  dealsTabDocsGovernance: 'company-deals-docs-and-governance',
  docsBase: 'docs-base',
  docsFinancialsBoardDecks: 'docs-financials-and-board-decks',
  docsCaptablesClosingDocs: 'docs-captables-and-closing-docs',
  kpisLegacy: 'kpis-legacy-collection',
  kpisStarbreaker: 'kpis-starbreaker',
  pipelines: 'pipelines',
  companiesSourcing: 'sourcing',
} as const;

/** Screens, cards and controls that lock when their feature is missing from the tenant's plans. */
export const FROST_TARGETS = [
  'portfolio',
  'entities',
  'finance',
  'deals',
  'deals.governance',
  'deals.documents',
  'docs',
  'docs.financialsAndBoardDecks',
  'docs.captablesAndClosingDocs',
  'kpis',
  'kpis.legacy',
  'pipeline',
  'sourcing',
] as const;
export type FrostTarget = (typeof FROST_TARGETS)[number];

/** The feature each target needs. */
export const FROST_FEATURE_KEYS: Record<FrostTarget, string> = {
  portfolio: FROST_FEATURES.portfolio,
  entities: FROST_FEATURES.entities,
  finance: FROST_FEATURES.finance,
  deals: FROST_FEATURES.dealsTab,
  'deals.governance': FROST_FEATURES.dealsTabDocsGovernance,
  'deals.documents': FROST_FEATURES.dealsTabDocsGovernance,
  docs: FROST_FEATURES.docsBase,
  'docs.financialsAndBoardDecks': FROST_FEATURES.docsFinancialsBoardDecks,
  'docs.captablesAndClosingDocs': FROST_FEATURES.docsCaptablesClosingDocs,
  kpis: FROST_FEATURES.kpisStarbreaker,
  'kpis.legacy': FROST_FEATURES.kpisLegacy,
  pipeline: FROST_FEATURES.pipelines,
  sourcing: FROST_FEATURES.companiesSourcing,
};

/** Placeholder copy until the final wording is confirmed. */
export const FROSTED_NOTICE = {
  title: 'Not included in your plan',
  message: 'Ask your account manager to add it.',
  action: 'Contact support',
} as const;
